@if (readonly()) {
    <si-form-item [label]="label() | translate">
        <si-pills-input
            [placeholder]="label() | translate"
            [formControl]="displayControl() ?? readonlyDisplayControl"
            [readonly]="true"
        />
    </si-form-item>
} @else {
    <si-form-fieldset
        [label]="label() | translate"
        [required]="isRequired()"
        [attr.data-invalid]="(submitted() || control().touched) && control().invalid"
    >
        <si-tree-view
            class="h-80 w-full"
            [items]="treeItems()"
            [trackBy]="trackTreeItem"
            [compactMode]="true"
            [enableSelection]="false"
            [inheritChecked]="false"
            [enableContextMenuButton]="false"
            [ariaLabel]="label() | translate"
            (treeItemClicked)="onTreeItemClicked($event)"
            (treeItemCheckboxClicked)="onTreeItemCheckboxClicked($event)"
        >
            <ng-template siTreeViewItem let-item="treeItem">
                <si-tree-view-item>
                    <tran-checkbox-tree-item
                        [label]="item.label ?? ''"
                        [isCategory]="item.customData?.kind === 'category'"
                        [selectedCount]="item.customData?.selectedCount ?? 0"
                        [totalCount]="item.customData?.totalCount ?? 0"
                    />
                </si-tree-view-item>
            </ng-template>
        </si-tree-view>
    </si-form-fieldset>
}
